import styled from 'styled-components';

const ColorNameLicense = styled.span.attrs(() => ({
    'data-color-names-license': 'https://github.com/meodai/color-names/blob/master/LICENSE',
    'data-nearest-color-license': 'https://github.com/dtao/nearest-color/blob/master/LICENSE.txt',
}))``;

export default ColorNameLicense;
